import React from "react";
import ModalPickerWithChooseButton from "components/Picker/ModalPickerWithChooseButton";
import ProductionList from "./ProductionList";
import { ModalPickerProps } from "../props";
import RemovableProduction from "components/Removables/RemovableProduction";
import { useOpenNewProductionSidePanel } from "components/SidePanel/Production/NewProductionSidePanel";

const ProductionModalPicker = (props: ModalPickerProps<server.dto.TourSmall>) => {
  const openNewProductionSidePanel = useOpenNewProductionSidePanel();
  const onChange = (value: server.dto.TourSmall) => {
    props.nonInPageEditing?.onChange(value);
    props.inPageEditing?.onChange(value, true);
  };
  const excludeKeys = props.excludeKeys;

  return <>
    <ModalPickerWithChooseButton
      canCreateNew={props.canCreateNew}
      onNewClicked={() => openNewProductionSidePanel({ onCreated: (production) => onChange(production), afterCreate: "closeSidebar" })}
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={site.currentEnvironment.production.plural}
      modalSize="tiny"
      renderModalContent={(closeModal) => <ProductionList
        excludeKeys={excludeKeys}
        onItemSelected={(production) => {
          closeModal();
          onChange(production);
        }}
      />}
      renderRemovable={(props) => <RemovableProduction {...props} />}
      {...props}
    />
  </>
};

export default ProductionModalPicker;